import React from 'react';
import PropTypes from 'prop-types';
import CalendarDayNew from './CalendarDayNew';
import CalendarMonthNew from './CalendarMonthNew';
import CalendarYearNew from './CalendarYearNew';
import * as commonLogic from '../../../logic/CommonLogic';

class DatePickerSummary extends React.Component {
  constructor(props) {
    super(props);

    this.handleCancel = this.handleCancel.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleHeaderDateClick = this.handleHeaderDateClick.bind(this);
    this.handleNoSelection = this.handleNoSelection.bind(this);
  }

  componentDidMount() {
    commonLogic.switchPageTopIconState(false);
  }

  componentWillUnmount() {
    commonLogic.switchPageTopIconState(true);
  }

  handleCancel(e) {
    // カレンダークローズ領域(オーバーレイ領域、絞り込み条件領域)
    // イベントの伝播を停止
    e.stopPropagation();
    let viewMode;
    if (this.props.data.kikanUnit === 'days' || this.props.data.kikanUnit === 'weeks') {
      viewMode = 'day';
    } else if (this.props.data.kikanUnit === 'months') {
      viewMode = 'month';
    } else if (this.props.data.kikanUnit === 'years') {
      viewMode = 'year';
    }
    this.props.comactions.cancelCalendar(viewMode);

  }

  handlePrev() {
    let newDate = this.props.data.displayDate;
    const isNohinCalendar = this.props.data.isNohinCalendar;
    const termData = this.props.data.termData;
    const startDate = commonLogic.getStartDate(isNohinCalendar, termData);
    if (this.props.data.calendarViewMode === 'day') {
      newDate.setMonth(newDate.getMonth() - 1);
    } else if (this.props.data.calendarViewMode === 'month') {
      newDate.setFullYear(newDate.getFullYear() - 1);
    } else {
      newDate.setFullYear(newDate.getFullYear() - 10);
    }
    if (newDate < startDate) {
      newDate = startDate;
    }
    this.props.comactions.updateDisplayDate(newDate);
  }

  handleNext() {
    let newDate = this.props.data.displayDate;
    const isNohinCalendar = this.props.data.isNohinCalendar;
    const nohinData = this.props.data.nohinTermData;
    const termData = this.props.data.termData;
    const endDate = commonLogic.getEndDate(isNohinCalendar, nohinData, termData);
    if (this.props.data.calendarViewMode === 'day') {
      newDate.setMonth(newDate.getMonth() + 1);
    } else if (this.props.data.calendarViewMode === 'month') {
      newDate.setFullYear(newDate.getFullYear() + 1);
    } else {
      newDate.setFullYear(newDate.getFullYear() + 10);
    }
    if (endDate < newDate) {
      newDate = endDate;
    }
    this.props.comactions.updateDisplayDate(newDate);
  }

  handleHeaderDateClick() {
    // 前後のデータがない場合は何もしない
    if (!this.prevIsActive(this.props.data.displayDate) && !this.nextIsActive(this.props.data.displayDate)) return;

    // viewModeがyearの場合は何もしない
    if (this.props.data.calendarViewMode === 'year') return;

    let viewMode;
    if (this.props.data.calendarViewMode === 'day') {
      viewMode = 'month';
    } else if (this.props.data.calendarViewMode === 'month') {
      viewMode = 'year';
    }
    this.props.data.isCalendarViewModeHeaderEvent = true;
    this.props.comactions.changeCalendarViewMode(viewMode);
  }

  handleNoSelection() {
    if (this.props.data.isNohinCalendar) {
      if (this.props.data.isFromDatePicker) {
        this.props.comactions.changeKaishibiFrom('');
      } else {
        this.props.comactions.changeKaishibiTo('');
      }
    }
  }

  isDispDayCalendar() {
    const { calendarViewMode, isNohinCalendar, kikanUnit } = this.props.data;
    return calendarViewMode === 'day' && (isNohinCalendar || kikanUnit === 'days' || kikanUnit === 'weeks');
  }

  isDispMonthCalendar() {
    const { calendarViewMode, isNohinCalendar, kikanUnit } = this.props.data;
    return calendarViewMode === 'month' && (isNohinCalendar || kikanUnit !== 'years');
  }

  isDispYearCalendar() {
    return this.props.data.calendarViewMode === 'year';
  }

  /**
   * カレンダーUIの前期間(>)表示判定
   * カレンダーUIが再描画されたら呼ばれる
   */
  prevIsActive(targetDate) {
    if (!targetDate) { return false; }

    // 表示するカレンダーの種類
    const viewMode = this.props.data.calendarViewMode;

    if (this.props.data.isNohinCalendar) {
      // 納品時期カレンダーの場合
      const nohinData = this.props.data.nohinTermData;
      if (!nohinData || !nohinData.data) { return false; }

      let currentYear;
      let limitYear;
      let termStartDate = new Date('2010-01-01T00:00:00');
      let isRange = false;

      // 表示したカレンダーのアイコン活性判定
      switch (viewMode) {
        case 'day':
        case 'week':
          // 日単位のカレンダーを表示する場合、前月の期間データが存在する場合は活性にする
          if (targetDate.getFullYear() > termStartDate.getFullYear()) {
            isRange = true; // 年が小さい場合
          } else if (targetDate.getFullYear() == termStartDate.getFullYear() && targetDate.getMonth() > termStartDate.getMonth()) {
            isRange = true; // 年が同じで月が小さい場合
          }
          break;
        case 'month':
          // 月単位のカレンダーを表示する場合、前年の期間データが存在する場合は活性にする
          currentYear = targetDate.getFullYear();
          limitYear = termStartDate.getFullYear();
          isRange = currentYear > limitYear;
          break;
        case 'year':
          // 月単位のカレンダーを表示する場合、前年の期間データ(年)が存在する場合は活性にする
          currentYear = Math.floor(targetDate.getFullYear() / 10) * 10;
          limitYear = termStartDate.getFullYear();
          isRange = currentYear > limitYear;
          break;
        default:
          break;
      }

      return isRange;

    } else {
      // 期間カレンダーの場合
      const termData = this.props.data.termData;
      if (!termData) return false;

      let currentYear;
      let limitYear;
      // 現在選択中の期間種類
      const kikanUnit = this.props.data.kikanUnit;
      let termStartDate;
      let isRange = false;

      // termDataの中にtargetDateが含まれているかチェック
      if (kikanUnit == 'weeks') {
        let firstTermId = termData[0].id;
        if (commonLogic.isISOWeekDate(firstTermId)) {
          // termの最終データ週の月よりも未満の場合は次へボタンを活性にする
          termStartDate = new Date(termData[0].from_date);
          termStartDate.setHours(0, 0, 0, 0);
        } else {
          termStartDate = new Date(termData[0].id);
        }
      } else {
        termStartDate = new Date(termData[0].id);
      }

      // 表示したカレンダーのアイコン活性判定
      switch (viewMode) {
        case 'day':
        case 'week':
          // 日単位のカレンダーを表示する場合、前月の期間データが存在する場合は活性にする
          if (targetDate.getFullYear() > termStartDate.getFullYear()) {
            isRange = true; // 年が小さい場合
          } else if (targetDate.getFullYear() == termStartDate.getFullYear() && targetDate.getMonth() > termStartDate.getMonth()) {
            isRange = true; // 年が同じで月が小さい場合
          }
          break;
        case 'month':
          // 月単位のカレンダーを表示する場合、前年の期間データが存在する場合は活性にする
          currentYear = targetDate.getFullYear();
          limitYear = termStartDate.getFullYear();
          isRange = currentYear > limitYear;
          break;
        case 'year':
          // 月単位のカレンダーを表示する場合、前年の期間データ(年)が存在する場合は活性にする
          currentYear = Math.floor(targetDate.getFullYear() / 10) * 10;
          limitYear = termStartDate.getFullYear();
          isRange = currentYear > limitYear;
          break;
        default:
          break;
      }

      return isRange;
    }
  }

  /**
   * カレンダーUIの後期間(>)表示判定
   */
  nextIsActive(targetDate) {
    if (!targetDate) return false;

    const viewMode = this.props.data.calendarViewMode;

    if (this.props.data.isNohinCalendar) {
      // 納品時期カレンダーの場合
      const nohinData = this.props.data.nohinTermData;

      let currentYear;
      let limitYear;
      let termEndDate = new Date(nohinData.data[0].model.nohinkaishibi);
      termEndDate.setHours(0, 0, 0, 0);
      let isRange = false;

      // 表示したカレンダーのアイコン活性判定
      switch (viewMode) {
        case 'day':
        case 'week':
          // 日単位のカレンダーを表示する場合、前月の期間データが存在する場合は活性にする
          if (targetDate.getFullYear() < termEndDate.getFullYear()) {
            isRange = true; // 年が小さい場合
          } else if (targetDate.getFullYear() == termEndDate.getFullYear() && targetDate.getMonth() < termEndDate.getMonth()) {
            isRange = true; // 年が同じで月が小さい場合
          }
          break;
        case 'month':
          // 月単位のカレンダーを表示する場合、前年の期間データが存在する場合は活性にする
          currentYear = targetDate.getFullYear();
          limitYear = termEndDate.getFullYear();
          isRange = currentYear < limitYear;
          break;
        case 'year':
          // 選択期間の開始年(2023年であれば2020年の10年後の2030年のデータ)から10年後以上の期間データが存在すれば活性にする
          currentYear = Math.floor(targetDate.getFullYear() / 10) * 10 + 10;
          limitYear = termEndDate.getFullYear();
          isRange = currentYear <= limitYear;
          break;
        default:
          break;
      }

      return isRange;

    } else {
      // 期間カレンダーの場合
      const termData = this.props.data.termData;
      if (!termData) return false;

      const kikanUnit = this.props.data.kikanUnit;

      let termEndDate;
      let isRange = false;
      // termDataの中にtargetDateが含まれているかチェック
      if (kikanUnit == 'weeks') {
        let firstTermId = termData[0].id;
        if (commonLogic.isISOWeekDate(firstTermId)) {
          // termの最終データ週の月よりも未満の場合は次へボタンを活性にする
          termEndDate = new Date(termData[termData.length - 1].to_date);
          termEndDate.setHours(0, 0, 0, 0);
        } else {
          termEndDate = new Date(termData[termData.length - 1].id);
        }
      } else {
        termEndDate = new Date(termData[termData.length - 1].id);
      }

      let currentYear;
      let limitYear;

      // 表示したカレンダーのアイコン活性判定
      switch (viewMode) {
        case 'day':
        case 'week':
          // 日単位のカレンダーを表示する場合、前月の期間データが存在する場合は活性にする
          if (targetDate.getFullYear() < termEndDate.getFullYear()) {
            isRange = true; // 年が小さい場合
          } else if (targetDate.getFullYear() == termEndDate.getFullYear() && targetDate.getMonth() < termEndDate.getMonth()) {
            isRange = true; // 年が同じで月が小さい場合
          }
          break;
        case 'month':
          // 月単位のカレンダーを表示する場合、前年の期間データが存在する場合は活性にする
          currentYear = targetDate.getFullYear();
          limitYear = termEndDate.getFullYear();
          isRange = currentYear < limitYear;
          break;
        case 'year':
          // 選択期間の開始年(2023年であれば2020年の10年後の2030年のデータ)から10年後以上の期間データが存在すれば活性にする
          currentYear = Math.floor(targetDate.getFullYear() / 10) * 10 + 10;
          limitYear = termEndDate.getFullYear();
          isRange = currentYear <= limitYear;
          break;
        default:
          break;
      }

      return isRange;
    }
  }

  render() {
    // カレンダーのヘッダー部分の日付表示
    let displayText = '';
    let prevClassName = '';
    let nextClassName = '';
    let addClassName = '';
    const displayDate = this.props.data.displayDate;
    const viewMode = this.props.data.calendarViewMode;
    if (displayDate) {
      if (viewMode === 'day') {
        displayText = `${displayDate.getFullYear()}年${displayDate.getMonth() + 1}月`;
      } else if (viewMode === 'month') {
        displayText = `${displayDate.getFullYear()}年`;
      } else if (viewMode === 'year') {
        const startYear = Math.floor(displayDate.getFullYear() / 10) * 10;
        const endYear = startYear + 9;
        displayText = `${startYear}年 - ${endYear}年`;
      }
      // prev「<」, next「>」の表示制御
      prevClassName = this.prevIsActive(displayDate) ? '' : 'hide-button';
      nextClassName = this.nextIsActive(displayDate) ? '' : 'hide-button';

      // カレンダー表示制御のためのクラス名
      addClassName = this.props.data.isOpenCalendar ? 'is-opened' : '';
    }

    // 年間カレンダーの場合はポインターにしない
    const headerDatePointerClsName = this.isDispYearCalendar() ? 'header-date-button-no-pointer' : 'header-date-button';

    return (
      <div className="date-picker-panel">
        <div className="date-picker-overlay" onClick={e => this.handleCancel(e)} />
        <div id="date_picker_view" className={`date-picker ${addClassName}`}>
          <div id="date-picker-header" className="date-picker-header">
            <button id="prev-button" className={`prev-button ${prevClassName}`} onClick={this.handlePrev}>
              <span className="arrow_left_calendar" />
            </button>
            <button id="header-date-button" className={headerDatePointerClsName} onClick={this.handleHeaderDateClick}>
              <span className="header-date">{displayText}</span>
            </button>
            <button id="next-button" className={`next-button ${nextClassName}`} onClick={this.handleNext}>
              <span className="arrow_right_calendar" />
            </button>
          </div>
          <div id="date-picker-body" className="date-picker-body">
            {this.isDispDayCalendar() && <CalendarDayNew data={this.props.data} comactions={this.props.comactions} isExec />}
            {this.isDispMonthCalendar() && <CalendarMonthNew data={this.props.data} comactions={this.props.comactions} isExec />}
            {this.isDispYearCalendar() && <CalendarYearNew data={this.props.data} comactions={this.props.comactions} isExec />}
          </div>
          {this.props.data.isNohinCalendar && (
            <div id="no-select" className="no-select" onClick={this.handleNoSelection}>
              <span id="no-select-text" className="no-select-text">指定なし</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

DatePickerSummary.propTypes = {
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
};

export default DatePickerSummary;
